<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path d="M32 18.133H18.133V32h-4.266V18.133H0v-4.266h13.867V0h4.266v13.867H32z"/>
</svg>
